import React from "react";
import PropTypes from "prop-types";
const DEFAULT_CLASSES = {
  container:
    "bg-primary br2 pa1 white absolute br-100 items-center justify-center flex",
  counter: "lh-copy fw7 flex items-center"
};

const DEFAULT_STYLES = {
  top: -8,
  right: -8,
  height: 24,
  width: 24,
  fontSize: 12
};

const CounterBubble = ({ count, customClasses, customStyles }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const styles = { ...DEFAULT_STYLES, ...customStyles };

  return (
    <div
      className={classes.container}
      style={{
        top: `${styles.top}px`,
        right: `${styles.right}px`,
        height: `${styles.height}px`,
        width: `${styles.width}px`,
        fontSize: `${styles.fontSize}px`
      }}
    >
      <div className={classes.counter}>{count}</div>
    </div>
  );
};

CounterBubble.propTypes = {
  customClasses: PropTypes.shape({
    container: PropTypes.string,
    counter: PropTypes.string
  }),
  customStyles: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  })
};

export default CounterBubble;
